import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

class Button extends Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.button = React.createRef();
    }

    click() {
        this.button.current.click();
    }

    render() {
        let classes = ['r-btn'];
        if (this.props.loading) {
            classes.push(`r-btn--loading`);
        }
        if (this.props.modes && this.props.modes.length) {
            let modes = this.props.modes.map(mode => `r-btn--${mode}`);
            classes = [...classes, ...modes];
        }

        return (
            <button
                ref={this.button}
                type={this.props.type || 'button'}
                disabled={this.props.disabled}
                className={
                    classes.join(' ') + ' ' + (this.props.className || '')
                }
                onClick={this.props.onClick}
            >
                {this.props.children}
            </button>
        );
    }
}

export default Button;
